/**
 * AddEpgCtrl controller
 * Add/Edit Epg
 */

import moment from 'moment'
import { GET_TIMEZONES, URL_PATTERN } from 'app/core/constants'
import { formatDateByTimezone } from '../../app/helpers/date'

/**
 * AddEpgCtrl controller
 *
 * @class AddEpgCtrl
 * @memberof mwApp/services
 * @see mwApp/services
 *
 * @ngdoc controller
 * @name mwApp/services.controller:AddEpgCtrl
 */
/* @ngInject */
export default function AddEpgCtrl ($scope, $http, $uibModalInstance, epg) {
  var vm = this

  vm.urlPattern = URL_PATTERN

  $scope.$watch('vm.task.sourceUrl', function (sourceUrl) {
    vm.isXMLSource = String(sourceUrl).slice(0, 3) === 'ftp'
  })

  /**
   * Is xml source url
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   * @type {Boolean}
   */
  vm.isXMLSource = false

  /**
   * Is xml source valid connection
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   * @type {Boolean}
   */
  vm.isXMLSourceConnected = false

  /**
   * Task
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   * @type {models.Epg}
   */
  vm.epg = epg

  /**
   * isNew flag
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   * @type {Boolean}
   */
  vm.isNew = epg._isNew()

  // create Date object with timezone offset from moment.js
  const st = vm.isNew ? moment().toObject() : moment(epg.startTime).toObject()
  vm.startTime = new Date(st.years, st.months, st.date, st.hours, st.minutes)

  /**
   * Timezones list
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   * @type {String[]}
   */
  GET_TIMEZONES().to(vm.timezones = [])

  /**
   * Create or edit epg, and close modal window afterwards
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    epg.startTime = formatDateByTimezone(vm.startTime).format('YYYY-MM-DDTHH:mm:ss[Z]')

    epg._save()
      .then(
        () => {
          vm.unsetDisable()
          // reload task after create/update
          epg._update()
            .finally(
              () => {
                $uibModalInstance.close(epg)
                vm.unsetDisable()
              }
            )
        }
      ).catch(() => {
        vm.unsetDisable()
      })
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Check connection by source URL
   *
   * @memberof mwApp/services.controller:AddEpgCtrl
   */
  vm.checkSourceConnection = () => {
    // TODO: may be move to task model?
    $http.get('api/...').then(() => {
      vm.isXMLSourceConnected = 'success'
    }).catch(() => {
      vm.isXMLSourceConnected = 'error'
    })
  }
}
